export const BASE_PATH = "ba3a";

export const NAV_PATH_NAMES = Object.freeze({
  CHANGE_LOG: "ba3a/change-log",
  ADMIN: "ba3a/admin",
  PROJECT: "ba3a/project",
  CO: "ba3a/co",
  SKU: "ba3a/sku",
  VED: "ba3a/fea",
  LOGIST: "ba3a/logistician",
  FINBLOCK: "ba3a/fin-block",
  CASHDESK: "ba3a/cashdesk",
  FIN_ACCOUNTING: "ba3a/fin-accounting",
  SERVICE: "ba3a/service",
  WAREHOUSE: "ba3a/warehouse",
  SETTINGS: "ba3a/settings", //* колесико настроек
  SYSTEM: "ba3a/system",
  BAZA_DOCS: "ba3a/docs",
});

export const API_ENDPOINTS = Object.freeze({
  ADMIN: {
    BASE: "admin",
    SETTINGS: "settings",
  },
  PROJECT: {
    BASE: "project",
    PAYMENT_DIRECTIVE_LIST_CO: "projectDirectiveList",
    PROJECT_INVOICE_LIST: "projectInvoiceList",
    PROJECT_SETTINGS: "projectSettings",
  },
  CO: {
    BASE: "co",
    TEMPLATE_REGISTER: "templateRegister",
    CONTROL: "control",
  },
  SKU: {
    BASE: "sku",
  },
  VED: {
    BASE: "fea",
    BOSS_REQUEST_REGISTER: "bos/request-registr",
    ORDER_PROCESSING: "orderProcess",
    REQUESTS_IN_PROGRESS: "reqInProgress",
    READY_STATUS_REQUESTS: "readyReq",
    PAYMENT_DIRECTIVE_LIST_VED: "paymentDirectiveList",
    FACTORY_MANAGEMENT: "factoryManagement",
    VED_SETTINGS: "vedSettingsGeneralNew",
  },
  LOGIST: {
    BASE: "logistician",
    SLEEPING_REQUESTS: "sleeping-requests",
    REQUESTS_REGISTER_BOSS: "bos/tp-pool-preregister",
    REQUESTS_REGISTER_IN_PROGRESS: "tp-pool-register",
    PAYMENT_DIRECTIVE_LIST_TP: "log-list-payment-to-tp",
    PAYMENT_DIRECTIVE_LIST_SP: "log-list-payment-to-sp",
    FACTORY: "tp-pool-factory",
    TRANSPORTATION: "tp-transportation",
    WAREHOUSE: "warehouse",
    FINAL_DESTINATION_BOSS: "bos/final-destination",
    FINAL_DESTINATION_MANAGER: "final-destination-Manager",
    LOG_SETTINGS: "settings",
  },
  FINBLOCK: {
    BASE: "fin-block",
    BANK_CLIENT: "bankClient",
    EXCHANGE_RATES: "exchangeRates",
    INVOICE_LIST: "finBlockInvoiceList",
    CANCELED_REQUESTS: "canceledRequests",
    CASHDESK_DIRECTIVE: "cashdeskDirective",
    CLIENT_DIRECTIVE_LIST: "clientDirectiveList",
    PAYMENT_DIRECTIVE_LIST_CO: "projectDirectiveList",
    PAYMENT_DIRECTIVE_LIST_VED: "paymentDirectiveList",
    PAYMENT_DIRECTIVE_LIST_TP: "paymentDirectiveListTP",
    PAYMENT_DIRECTIVE_LIST_SP: "paymentDirectiveListStatement",
    TRANSACTION_DAY_LIST: "finBlockTransactionDayList",
    FIN_SETTINGS: "fin_settings",
  },
  CASHDESK: {
    BASE: "cashdesk",
    EXCHANGE_RATES: "exchangeRates",
    PAYMENT_DIRECTIVE_LIST_CO: "directiveList",
    INVOICE_LIST: "invoiceList",
    CASHDESK_DIRECTIVE: "cashdeskDirective",
    TRANSACTION_DAY_LIST: "transactionDayList",
    PROJECT: "project",
  },
  FIN_ACCOUNTING: {
    BASE: "fin-accounting",
  },
  SERVICE: {
    BASE: "service",
  },
  WAREHOUSE: {
    BASE: "warehouse",
    REQUESTS_FOR_PLANNING_REGISTER: "planningReqRegister",
    WAREHOUSE_INVENTORY_ORDER_CO: "warehouseInventoryOrderCo",
    WAREHOUSE_INVENTORY_RETAIL: "warehouseInventoryRetail",
    GOODS_RECEIVING_WAREHOUSE: "goodsReceivingWarehouse",
    WAREHOUSE_SETTINGS: "warehouseSettings",
  },
  CHANGE_LOG: {
    BASE: "change-log",
    CHANGES_LIST: "changesList",
  },
  SYSTEM: {
    BASE: "system",
    TASKS_LIST: "tasks-list",
    ROUTINE_PROCEDURES: "routine-procedures",
  },
  BAZA_DOCS: {
    BASE: "docs",
    BAZA_DOCUMENTATION: "bazaDocumentation",
  },
});
